import {useOnboardingStatus} from "@mytour/platform";
import {useState} from "react";
import {Button} from "reactstrap";

type Props = {
  onClick?: () => void;
  disabled: boolean;
};

export function CloseOnboardingButton({onClick, disabled}: Props) {
  const [pending, setPending] = useState(false);

  const {setOnboardingStatus} = useOnboardingStatus();
  return (
    <Button
      id="closeButton"
      type="button"
      color="secondary"
      onClick={handleClose}
      disabled={disabled || pending}
    >
      <span>Fermer</span>
    </Button>
  );

  function handleClose() {
    if (onClick) {
      onClick();
      return;
    }
    setPending(true);
    try {
      setOnboardingStatus("FINISHED");
    } finally {
      setPending(false);
    }
  }
}
